import config from 'config';

import Fetch from 'tools/Fetch';

import {
    onUnauthorized,
} from 'entities/auth/functions';

import {
    ENTITY_PATH,
} from '../constants';
import {
    IGetFeatureToggleSettingResponse,
} from '../responses/get-feature-toggle-setting.response';

export function getFeatureToggleSettingFetch(): Promise<IGetFeatureToggleSettingResponse> {
    return new Fetch<IGetFeatureToggleSettingResponse>({
        url: `${config.URL}${ENTITY_PATH}/feature_toggle`,
        method: 'GET',
    })
        .on([200], (body) => {
            return body;
        })
        .on([401], (body) => {
            onUnauthorized();

            return body;
        })
        .on([403, 404, 500], (body) => {
            return body;
        })
        .exec();
}
